
import React from 'react';
import { Line,Bar } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';

// Register the components you want to use
ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    BarElement,
    Title,
    Tooltip,
    Legend
);

const LeadsBarChart = ({bar_graph_data,labels,legend=false,indexAxis="x" }) => {
   

    // const data =  {
    //     labels: [
    //         'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 
    //         // 'Jul', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'
    //       ],
    //     datasets: [
    //         {
    //             label: 'Facebook',
    //             backgroundColor: '#D3A4FF', 
    //             borderColor: '#D3A4FF',
    //             borderWidth: 1,
    //             data: [150, 120, 90, 60, 200,700] // Leads data
    //         },
    //         {
    //             label: 'Instagram',
    //             backgroundColor: '#FFB1E0', // Green bars
    //             borderColor: '#FFB1E0',
    //             borderWidth: 1,
    //             data: [100, 200, 450, 200, 500,600] // Spent data
    //         },
    //         {
    //             label: 'Twitter',
    //             backgroundColor: '#95F3FA', // Red bars
    //             borderColor: '#95F3FA',
    //             borderWidth: 1,
    //             data: [120, 220, 430, 120, 200,600]
    //         },
    //         {
    //             label: 'LinkedIn',
    //             backgroundColor: '#FFE58A', // Red bars
    //             borderColor: '#FFE58A',
    //             borderWidth: 1,
    //             data: [130, 250, 230, 520, 100,500]
    //         }
    //     ]
    // }

    let data =  {
        labels:labels?.length>0?labels: [
           
            // 'Jul', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'
          ],
        datasets: [
            {
                label: 'Facebook',
                backgroundColor: '#D3A4FF', 
                borderColor: '#D3A4FF',
                borderWidth: 1,
                data: [150, 120, 90] // Leads data
            },
            {
                label: 'Instagram',
                backgroundColor: '#FFB1E0', // Green bars
                borderColor: '#FFB1E0',
                borderWidth: 1,
                data: [100, 200, 450] // Spent data
            },
            {
                label: 'Twitter',
                backgroundColor: '#95F3FA', // Red bars
                borderColor: '#95F3FA',
                borderWidth: 1,
                data: [120, 220, 430, 120, 200,600]
            },
            {
                label: 'LinkedIn',
                backgroundColor: '#FFE58A', // Red bars
                borderColor: '#FFE58A',
                borderWidth: 1,
                data: [130, 250, 230]
            }
        ]
    }
    if(bar_graph_data?.length>0)
    {
        data={...data,datasets:bar_graph_data}
        

    }

    const options = {
        responsive: true,
        indexAxis:indexAxis,
        maintainAspectRatio: true,
        scales: {
            y: {
                beginAtZero: true,
                display:true,
                ticks: {
                    callback: function (value) {
                      return value >= 1000 ? `${value / 1000}k` : value;
                    }
                  }
            },
            x: {
                grid:{
                    display:false,
                    drawBorder:true
                }
            },
            
        },
        plugins: {
            legend: {
                display: legend ,
                position:'bottom'
            }
        }

    }





    return <Bar data={data} options={options} height={'100%'}/>;
};

export default LeadsBarChart;
